<template>
  <div id="app">
    <AppHeader />
    <HeroSection id="hero" />
    <ServicesSection id="services" />
    <PortfolioSection id="portfolio" />
    <AboutContactSection id="about" />
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import HeroSection from './components/HeroSection.vue'
import ServicesSection from './components/ServicesSection.vue'
import PortfolioSection from './components/PortfolioSection.vue'
import AboutContactSection from './components/AboutContactSection.vue'
import AppFooter from './components/AppFooter.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    HeroSection,
    ServicesSection,
    PortfolioSection,
    AboutContactSection,
    AppFooter
  }
}
</script>

<style lang="scss">
@import './assets/styles.scss';

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
